import { useLocation } from "react-router";

export function isNil(value) {
  return value === null || value === undefined;
}

export const isObject = (value) => typeof value === "object" && value !== null;

export function hasProperty(object, key) {
  const has = Object.prototype.hasOwnProperty;
  return has.call(object, key);
}

export const useQuery = () => new URLSearchParams(useLocation().search);
